// FIX-BUG-CARD-PUSH: the "שליחת התראת בדיקה" answer in words: VAPID missing / no subscription / the push service
// refused (its status code) / sent. Pure (gets `t`), so it is unit-tested.

type T = (key: string, opts?: Record<string, unknown>) => string;

export interface TestPushResponse {
  configured: boolean;
  switched_off?: boolean;
  devices: number;
  sent: number;
  failed: number;
  this_device_registered?: boolean | null;
  outcome?: 'not_configured' | 'no_device' | 'sent' | 'failed' | 'partial';
  results?: { ok: boolean; status_code: number | null; message: string | null; this_device: boolean; removed: boolean }[];
}

export function testPushLines(r: TestPushResponse | undefined | null, t: T): { headline: string; details: string[] } {
  if (!r) return { headline: t('push.testFailed'), details: [] };
  const outcome = r.outcome ?? (!r.configured ? 'not_configured' : r.devices === 0 ? 'no_device' : r.failed === 0 ? 'sent' : r.sent === 0 ? 'failed' : 'partial');
  const details: string[] = [];
  if (r.switched_off) details.push(t('push.testSwitchedOff'));
  if (r.this_device_registered === false && outcome !== 'not_configured') details.push(t('push.testThisDeviceNotRegistered'));
  for (const d of r.results ?? []) {
    if (d.ok) continue;
    const who = d.this_device ? t('push.testThisDevice') : t('push.testOtherDevice');
    const code = d.status_code ?? '?';
    const why = d.status_code === 403 ? t('push.testWhy403')
      : d.removed ? t('push.testWhyGone')
        : d.status_code === null ? t('push.testWhyNetwork') : '';
    details.push(`${who}: ${t('push.testRefused', { code })}${why ? ` ${why}` : ''}`);
  }
  const headline = outcome === 'not_configured' ? t('push.testNotConfigured')
    : outcome === 'no_device' ? t('push.testNoDevice')
      : outcome === 'failed' ? t('push.testAllFailed', { n: r.failed })
        : outcome === 'partial' ? t('push.testPartial', { sent: r.sent, failed: r.failed })
          : t('push.testSent');
  return { headline, details };
}
